var _g, _g2, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkanywhere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.403,
    height: 441.595,
    viewBox: "0 0 799.403 441.595",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-864.885 -546.821)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1484.002 636.904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.536,420.89a.845.845,0,0,1-.6-.248l-40.791-40.763a.847.847,0,1,1,1.2-1.2l40.791,40.763a.847.847,0,0,1-.6,1.446Z",
    transform: "translate(-294.63 -280.644)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.052,303.8c0-49.785,40.358-167.923,90.143-167.923S398.339,254.019,398.339,303.8a90.143,90.143,0,1,1-180.286,0Z",
    transform: "translate(-218.052 -135.882)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.407,549.284a.741.741,0,0,1-.741-.741V237.757a.741.741,0,0,1,1.482,0V548.543A.741.741,0,0,1,339.407,549.284Z",
    transform: "translate(-249.265 -230.507)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.951,305.988a.739.739,0,0,1-.524-.217l-35.679-35.679a.741.741,0,1,1,1.048-1.048l35.678,35.679a.741.741,0,0,1-.524,1.265Z",
    transform: "translate(-236.809 -170.285)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.407,380.915a.741.741,0,0,1-.524-1.265l59.75-59.751a.741.741,0,1,1,1.048,1.048L339.931,380.7a.739.739,0,0,1-.524.217Z",
    transform: "translate(-249.265 -183.442)",
    fill: "#d6d6e3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(864.885 546.821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.052,353.275c0-64.452,52.249-217.394,116.7-217.394s116.7,152.942,116.7,217.394a116.7,116.7,0,1,1-233.4,0Z",
    transform: "translate(-218.052 -135.882)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.626,641.281a.96.96,0,0,1-.96-.96V237.975a.96.96,0,0,1,1.919,0V640.321A.96.96,0,0,1,339.626,641.281Z",
    transform: "translate(-222.925 -228.588)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.681,316.936a.956.956,0,0,1-.678-.281l-46.19-46.19a.96.96,0,1,1,1.357-1.357l46.19,46.19a.96.96,0,0,1-.679,1.638Z",
    transform: "translate(-220.981 -141.252)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.626,398.954a.96.96,0,0,1-.679-1.638L416.3,319.962a.96.96,0,0,1,1.357,1.357L340.3,398.673A.957.957,0,0,1,339.626,398.954Z",
    transform: "translate(-222.925 -143.307)",
    fill: "#d6d6e3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M964.46,660.877H237.926c-.54,0-.978-.858-.978-1.917s.438-1.916.978-1.916H964.46c.54,0,.978.858.978,1.916S965,660.877,964.46,660.877Z",
    transform: "translate(644.968 298.636)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1144.484,601.583a5.33,5.33,0,0,0,0-10.66h-50.635V569.6h50.635a5.33,5.33,0,0,0,0-10.66H712.758a5.33,5.33,0,1,0,0,10.66h50.634v21.32H712.758a5.33,5.33,0,0,0,0,10.66h50.635V622.9H712.758a5.33,5.33,0,0,0,0,10.66h50.635v21.32h-45.3a10.66,10.66,0,1,0,0,21.32h43.129a7.95,7.95,0,0,0-.489,2.665v74.619a7.995,7.995,0,1,0,15.99,0V678.868a7.941,7.941,0,0,0-.489-2.665h304.786a7.947,7.947,0,0,0-.489,2.665v74.619a7.995,7.995,0,1,0,15.99,0V678.868a7.949,7.949,0,0,0-.489-2.665h43.129a10.66,10.66,0,1,0,0-21.32h-45.3v-21.32h50.635a5.33,5.33,0,0,0,0-10.66h-50.634v-21.32ZM774.052,569.6h309.137v21.32H774.052Zm309.137,85.279H774.052v-21.32h309.137Zm0-31.98H774.052v-21.32h309.137Z",
    transform: "translate(376.872 196.748)",
    fill: "#d6d6e3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.841,
    cy: 5.841,
    r: 5.841,
    transform: "translate(1242.793 808.997)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M603.968,80.8l-2.71-16.942,18.3-7.454,2.711,25.757Z",
    transform: "translate(691.24 668.447)",
    fill: "#9f616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M667.546,231.924c-6.19,4.048-13.289,4.136-15.87.2s.354-10.413,6.546-14.46a18.507,18.507,0,0,1,8.2-3.033l26.436-16.821,7.628,12.576-26.872,15.246A18.508,18.508,0,0,1,667.546,231.924Z",
    transform: "translate(578.389 626.008)",
    fill: "#9f616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M646.077,95.367h0a15.99,15.99,0,0,1,14.287,19.471l-11.031,48.692L598.559,193.21l-6.25-15.883,34.628-25.776,1.854-40.97a15.99,15.99,0,0,1,17.287-15.214Z",
    transform: "translate(659.001 656.771)",
    fill: "#7FE7EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M791.134,340.559l-10.756,16.078-2,5.038-5.9,3.729L750.12,355.024l4.845-10.605,14.518.958,5.966-9.153Z",
    transform: "translate(418.19 584.461)",
    fill: "#9f616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M792.763,353.913l.222,2.217,25.8,6.937s-6.888,9.167-8.04,11.074-37.391-19.977-42.383-24.032-.247-7.958-.247-7.958l29.078,2.952-4.427,8.817h0Z",
    transform: "translate(379.379 582.682)",
    fill: "#090814"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M716.219,210.2l2.863,6.772s6.248,19.267-25.776,26.037-48.683,3.906-48.683,3.906l-55.2,66.133-14.055-12.237,43.977-66.675a24.206,24.206,0,0,1,12.066-9.468l66.246-23.655Z",
    transform: "translate(612.044 625.048)",
    fill: "#090814"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M737.718,382.058l-7.075,18.005-.882,5.349-4.965,4.9-24.062-5.374,2.471-11.4,14.389-2.159,3.878-10.214Z",
    transform: "translate(506.17 570.971)",
    fill: "#9f616a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M737.832,405.831l.69,2.118,26.681,1.278s-4.775,10.424-5.494,12.534-40.79-11.546-46.532-14.439-1.937-7.722-1.937-7.722l29.04-3.322Z",
    transform: "translate(472.197 566.435)",
    fill: "#090814"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M668.2,213.933l4.241,6.006s10.213,17.493-19.633,30.933-46.737,14.2-46.737,14.2l-39.829,76.381-16.345-8.96,31.662-82.061,30.863-28.32,55.78-8.178Z",
    transform: "translate(675.317 621.166)",
    fill: "#090814"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M547.987,81.055l23.694-7.811L594,97.675a43.712,43.712,0,0,1,11.4,27.678l2.466,59.59-59.1-10.676-.781-93.212Z",
    transform: "translate(742.915 663.395)",
    fill: "#7FE7EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.927,
    cy: 20.927,
    r: 20.927,
    transform: "translate(1279.573 697.614)",
    fill: "#9f616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M529.845,399.028h-.023a.82.82,0,0,1,.349,0A1.611,1.611,0,0,0,529.845,399.028Z",
    transform: "translate(833.328 565.616)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M535.126,357.594c.176.061.256.091.273.1l-.266-.1Z",
    transform: "translate(824.39 578.047)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M535.58,337.5l.076-.026c-.317.226-.346.169-.212.088.047-.019.084-.04.128-.06Z",
    transform: "translate(823.962 584.087)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M436.972,14.413c-.546.318-1.278-.164-1.458-.774a3.194,3.194,0,0,1,.227-1.858c.342-1.011.676-2.012,1.022-3.023a15.544,15.544,0,0,1,3.055-5.989c2.363-2.461,6.133-3.088,9.509-2.632,4.344.586,8.629,2.939,10.65,6.828s1.158,9.328-2.493,11.755c5.207,5.965,7.015,12.614,6.73,20.517S455.309,54.427,449.687,60c-1.255-.758-2.4-4.327-1.7-5.622s-.3-2.794.555-3.993,1.573.709.709-.48c-.546-.75,1.581-2.469.774-2.917-3.919-2.172-5.223-7.056-7.683-10.8A18.386,18.386,0,0,0,428.9,28.111a12.719,12.719,0,0,0-8.523,1.947,7.986,7.986,0,0,0-3.438,7.716,6.853,6.853,0,0,1,1.426-10.733,11.187,11.187,0,0,1,2.379-10.552c2.534-2.794,12.81-2.314,16.509-1.581l-.285-.489h0l.008-.008Z",
    transform: "translate(863.397 677.857)",
    fill: "#090814"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M428.65,34.63c4.9.529,8.433,4.775,11.423,8.689,1.719,2.257,3.528,4.751,3.479,7.594-.041,2.869-1.964,5.337-2.884,8.05A12.139,12.139,0,0,0,444.2,71.747a7.042,7.042,0,0,1-7.944-5.516c-.709-4.114,2.412-8.091,2.044-12.255-.326-3.667-3.219-6.486-5.671-9.232s-4.766-6.38-3.634-9.884l-.342-.236h0Z",
    transform: "translate(872.291 671.445)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.946, -0.326, 0.326, 0.946, 1145.452, 815.06)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.148.953.016,19.553a1.145,1.145,0,0,0,.067.616L24.66,81.574a1.145,1.145,0,0,0,2.207-.377l1.041-24.676a1.145,1.145,0,0,0-.084-.479L5.338.713a1.145,1.145,0,0,0-2.19.241Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.977,0,0,15.979,21.809,72.014l2.83-18.025Z",
    transform: "translate(1.911 2.381)",
    fill: "#7FE7EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.55,31.231c-.506,2.095-66.923,4.362-67.613,3.729a14.974,14.974,0,0,1-1.6-2.622C.645,31.018,0,29.7,0,29.7L1.092,7.416,66.518,0s2.9,18.593,3.8,27.135A21.744,21.744,0,0,1,70.55,31.231Z",
    transform: "translate(25.472 50.058)",
    fill: "#d6d6e3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.006,2.089,0,21.281,30.694,19.1,29.336,0Z",
    transform: "translate(35.703 57.746)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.185,1.261,0,1.238,1.449,9.4,18.5,8.185,17.923,0Z",
    transform: "translate(71.007 61.724)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.07,4.1c-.5,2.095-66.788,4.362-67.475,3.728A14.98,14.98,0,0,1,0,5.2L68.841,0A21.791,21.791,0,0,1,69.07,4.1Z",
    transform: "translate(26.893 77.193)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M637.764,238.5c-6.19,4.048-13.289,4.136-15.87.2s.354-10.413,6.546-14.46a18.506,18.506,0,0,1,8.2-3.033l26.44-16.819,7.628,12.576L643.83,232.208a18.508,18.508,0,0,1-6.067,6.3Z",
    transform: "translate(629.009 624.032)",
    fill: "#9f616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M616.3,101.946h0a15.99,15.99,0,0,1,14.287,19.471L619.55,170.109l-50.772,29.682-6.248-15.883,34.627-25.776,1.854-40.97a15.99,15.99,0,0,1,17.283-15.214h0Z",
    transform: "translate(709.623 654.798)",
    fill: "#7FE7EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkanywhere);
export default __webpack_public_path__ + "static/media/workanywhere.f5ce104dad28f92e9d86a73c3a2d8395.svg";
export { ForwardRef as ReactComponent };